import { render, staticRenderFns } from "./parrainage.register.vue?vue&type=template&id=388b33aa&scoped=true"
import script from "./parrainage.register.vue?vue&type=script&lang=js"
export * from "./parrainage.register.vue?vue&type=script&lang=js"
import style0 from "./parrainage.register.vue?vue&type=style&index=0&id=388b33aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388b33aa",
  null
  
)

export default component.exports